<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright"><a id="page_iv"></a><span class="small">NEW YORK UNIVERSITY PRESS</span><br/>New York and London<br/><a class="nounder" href="http://www.nyupress.org" target="_blank">www.nyupress.org</a></p>
<p class="copyright">© 2010 by New York University<br/>All rights reserved</p>
<p class="copyright">Library of Congress Cataloging-in-Publication Data<br/>Race, ethnicity, and policing : new and essential readings /<br/>edited by Stephen K. Rice and Michael D. White.<br/>p. cm.<br/>Includes bibliographical references and index.<br/>ISBN-13: 978-0-8147-7615-5 (cl : alk. paper)<br/>ISBN-10: 0-8147-7615-9 (cl : alk. paper)<br/>ISBN-13: 978-0-8147-7616-2 (pb : alk. paper)<br/>ISBN-10: 0-8147-7616-7 (pb : alk. paper)<br/>1. Racial profiling in law enforcement. 2. Police—Attitudes.<br/>3. Crime and race. I. Rice, Stephen K. II. White, Michael D.<br/>(Michael Douglas), 1951 –<br/>HV7936.R3R29 2010<br/>363.2′3089—dc22           2009039286</p>
<p class="copyright">New York University Press books are printed on acid-free paper,<br/>and their binding materials are chosen for strength and durability.<br/>We strive to use environmentally responsible suppliers and materials<br/>to the greatest extent possible in publishing our books.</p>
<p class="copyright">Manufactured in the United States of America</p>
<p class="copyright">c   10 9 8 7 6 5 4 3 2 1<br/>p   10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?0fb3c66c